import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsPersisted } from 'state/workspaces/workspace.actions';

// TODO catch Error in Epic
export function persistTabsDescriptionOnWorkspaceTabsUpdatedEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient, frontLogger, selectors: { getPersistedTabs } }) => {
    return actions$.pipe(
      ofType(
        'WORKSPACE_TAB_PERSIST_REQUESTED',
        'WORKSPACE_TAB_ACTIVATED',
        'WORKSPACE_TAB_RENAMED',
        'WORKSPACE_TAB_QUOTE_REPRICED',
        'WORKSPACE_RFQ_LOAD_REQUESTED',
        'WORKSPACE_TAB_CREATED',
        'WORKSPACE_ADVISORY_TAB_CREATED',
        'WORKSPACE_TAB_CLONED',
        'WORKSPACE_TAB_MOVED',
        'WORKSPACE_TAB_UNACTIVATED',
        'WORKSPACE_QUOTE_RELOADED',
      ),
      withLatestFrom(state$),
      switchMap(([action, state]) => {
        const api = tabsApiConnector(httpClient, action.workspace);
        const tabsDescription = getPersistedTabs(state, action.workspace);
        return api.updateTabDescriptions(tabsDescription).pipe(
          map(() => workspaceTabsPersisted(tabsDescription, action.workspace)),
          catchError((_: Error) => {
            frontLogger.error('Error persisting tabs description on workspace tabs update');
            return EMPTY;
          }),
        );
      }),
    );
  };
}
